export const RIDE_SERVICE_OPTIONS = [
  { value: 'outstation', label: 'Outstation only (Book a Taxi)' },
  { value: 'daily', label: 'Daily rides only' },
  { value: 'both', label: 'Outstation and daily' },
];

export function rideServiceLabel(value) {
  const hit = RIDE_SERVICE_OPTIONS.find((item) => item.value === value);
  return hit?.label || value || '—';
}

export function isAppOriginDriver(driver) {
  return (
    driver?.origin === 'app' ||
    driver?.signup_source === 'app' ||
    Boolean(String(driver?.app_profile_id || '').trim())
  );
}

/** Effective trip type when ride_services column is missing or null. */
export function normalizeRideServices(driver) {
  const raw = String(driver?.ride_services ?? '').toLowerCase().trim();
  if (raw === 'outstation' || raw === 'daily' || raw === 'both') return raw;
  // App signups without an explicit type: treat as both until ops marks daily-only.
  return isAppOriginDriver(driver) ? 'both' : 'outstation';
}

export function driverMatchesAssignedId(driver, assignedId) {
  if (!driver || !assignedId) return false;
  const aid = String(assignedId);
  if (String(driver.id) === aid) return true;
  if (String(driver.hiring_id || '') === aid) return true;
  if (String(driver.app_profile_id || '') === aid) return true;
  return false;
}

export function resolveDriverSelectId(drivers, assignedId) {
  if (!assignedId) return '';
  const aid = String(assignedId);
  const list = Array.isArray(drivers) ? drivers : [];
  const hit = list.find((d) => driverMatchesAssignedId(d, aid));
  return hit ? String(hit.id) : aid;
}

/** Which driver trip types may be assigned for this ride. */
export function allowedDriverServicesForRide(ride) {
  const product = String(ride?.product || '').toLowerCase();
  const source = String(ride?.source || '').toLowerCase();
  if (product === 'daily') {
    return ['daily', 'both'];
  }
  if (source === 'web' || product === 'website' || !product || product === 'outstation') {
    return ['outstation', 'both'];
  }
  return ['outstation', 'both'];
}

export function driverCanAssignToRide(driver, ride) {
  const allowed = allowedDriverServicesForRide(ride);
  return allowed.includes(normalizeRideServices(driver));
}

export function filterDriversForRide(drivers, ride, { keepDriverId } = {}) {
  const list = Array.isArray(drivers) ? drivers : [];
  if (!ride) {
    return list.filter((d) => ['outstation', 'both'].includes(normalizeRideServices(d)));
  }
  const filtered = list.filter((d) => driverCanAssignToRide(d, ride));
  const keepId = keepDriverId ? String(keepDriverId) : '';
  if (keepId && !filtered.some((d) => driverMatchesAssignedId(d, keepId))) {
    const current = list.find((d) => driverMatchesAssignedId(d, keepId));
    if (current) return [current, ...filtered];
  }
  return filtered;
}
